import React from 'react';
import { CheckIcon } from 'lucide-react';
const RESOURCES = ['Visual diagnostic maps.', 'Troubleshooting flows.', 'Multimeter testing pathways.', 'Wiring & circuit references.', 'Protection-device diagnostics.', 'Motor & control diagnostics.', 'Testing sequences.', 'Real-world troubleshooting cases.'];
export function StopSearching() {
  return <section className="bg-tech px-4 py-4 sm:py-6" data-id="element-169" data-mp="2dw0wsouo2ail">
      <div className="mx-auto max-w-3xl" data-id="element-170" data-mp="28vd5e22izrnu">
        <h2 className="text-center text-lg leading-tight text-navy sm:text-3xl" data-id="element-171" data-mp="28wfwob3rfw4a">
          😩 STOP SEARCHING FOR WHAT TO TEST NEXT
        </h2>
        <p className="mt-1.5 text-[13px] font-medium leading-snug text-carbon/80 sm:text-base" data-id="element-172" data-mp="1z5tkkqv95nqc">
          Your time should go into diagnosing the electrical problem — not
          searching through disconnected diagrams, manuals and saved references.
        </p>
        <p className="mt-1 text-[13px] font-bold leading-snug text-navy sm:text-base" data-id="element-173" data-mp="1l50ldsu0a4gw">
          ELECTRICAL DIAGNOSTIC PRO™ brings the resources together for you.
        </p>

        <ul className="mt-2 grid gap-1 sm:grid-cols-2" data-id="element-174" data-mp="1wxly6a3urnar">
          {RESOURCES.map(item => <li key={item} className="flex items-start gap-2 rounded-md border border-navy/10 bg-white px-2.5 py-1.5 text-[13px] font-semibold text-carbon" data-id="element-175" data-mp="21sjhc9uujd1d">
              <CheckIcon className="mt-0.5 h-4 w-4 shrink-0 text-navy" aria-hidden="true" strokeWidth={3} data-id="element-176" data-mp="1sw0qd366dz7f" />
              {item}
            </li>)}
        </ul>

        <p className="mt-2 text-[13px] font-medium leading-snug text-carbon/80 sm:text-base" data-id="element-177" data-mp="26ps0acntjl3o">
          Everything organized so you can identify the relevant pathway, follow
          the checks and verify findings using professional judgment and
          equipment-specific information.
        </p>
        <p className="mt-1.5 text-center font-display text-base uppercase text-navy sm:text-2xl" data-id="element-178" data-mp="1096a6ige5lzr">
          Less searching. More structured diagnosis.
        </p>
      </div>
    </section>;
}